<template>
  <path
    d="m 26.5,31.707009 a 6.2777053,6.2777053 0 0 1 -6.277705,-6.277705 c 0,-4.185137 6.277705,-11.247555 6.277705,-11.247555 0,0 6.277705,7.062418 6.277705,11.247555 A 6.2777053,6.2777053 0 0 1 26.5,31.707009 Z"
    fill="white"
  />
</template>
